import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AppOAuthStore } from 'src/app/models/AppOAuthSotarge';
import { httpConnect } from 'src/app/services/httpConnect.service';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent implements OnInit {
  public userImage = "assets/img/users/user.jpg";
  constructor(
    public appOAuthStore: AppOAuthStore,
    private router: Router,
    private httpConn: httpConnect,
    private _snack: MatSnackBar
  ) {
  }


  ngOnInit() {
  }



  OnLogOutClick() {
    // -------- Se obtiene el tiempo actual
    const date_logoutNav = this.getFormattedDate(new Date());
    
    const id_usuario: number = +this.appOAuthStore.getItem("id_usuario");

    // this.httpConn.postAPI('Seguridad', 'Logout', { id_usuario: id_usuario, date_logoutNav: date_logoutNav })
    this.httpConn.postAPI('Seguridad', 'Logout', { id_usuario: id_usuario })
      .subscribe(data => {
        if (data.success) {
          this.appOAuthStore.clear();
          this.router.navigate(['/']);
        }

        this._snack.open(data.response, null, { duration: 3000, verticalPosition: 'top', horizontalPosition: 'right' });

      }, error => {
        this._snack.open('Ocurrio un error al cerrar la sesion', null, { panelClass: ['snackbar-center-text'] });
      });

  }

  getFormattedDate(date: Date): string {
    const pad = (n: number) => n < 10 ? '0' + n : n;
    return date.getFullYear() + '-' +
      pad(date.getMonth() + 1) + '-' +
      pad(date.getDate()) + ' ' +
      pad(date.getHours()) + ':' +
      pad(date.getMinutes()) + ':' +
      pad(date.getSeconds());
  }

}
